const num = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const hasValue = (value) => value !== null && value !== undefined && value !== '';

function emptyHotelItem(itemLabel = null, sortOrder = 0) {
  return {
    item_type: 'hotel',
    item_label: itemLabel,
    sort_order: sortOrder,
    target_cost: null,
    supplier_refund: null,
    supplier_cancel_fee: null,
    additional_cost: null,
    customer_refund: null,
    customer_additional_payment: null,
    misc_amount: null,
    memo: null,
  };
}

function normalizeNightlyRates(rates) {
  if (!Array.isArray(rates)) return [];
  return rates
    .map((row, index) => ({
      night: Number.isInteger(Number(row?.night)) ? Number(row.night) : index + 1,
      amount: hasValue(row?.amount) ? num(row.amount) : null,
    }))
    .filter((row) => hasValue(row.amount) && num(row.amount) !== 0);
}

function hotelNightLabel(hotel, hotelIndex, rate, nightIndex, multipleHotels) {
  const hotelName = String(hotel?.hotel_name || '').trim();
  const prefix = multipleHotels ? (hotelName || `호텔 #${hotelIndex + 1}`) : '호텔';
  const night = Number.isInteger(Number(rate?.night)) ? Number(rate.night) : nightIndex + 1;
  return `${prefix} · ${night}박`;
}

function hotelTotalLabel(hotel, hotelIndex, multipleHotels) {
  const hotelName = String(hotel?.hotel_name || '').trim();
  const prefix = multipleHotels ? (hotelName || `호텔 #${hotelIndex + 1}`) : '호텔';
  return `${prefix} · 1박`;
}

function sourceHotelRows(sourceHotels = []) {
  const rows = [];
  const hotels = (sourceHotels || []).filter(Boolean);
  const multipleHotels = hotels.length > 1;

  hotels.forEach((hotel, hotelIndex) => {
    const rates = normalizeNightlyRates(hotel?.nightly_rates);
    if (rates.length) {
      rates.forEach((rate, nightIndex) => {
        rows.push({
          ...emptyHotelItem(hotelNightLabel(hotel, hotelIndex, rate, nightIndex, multipleHotels), rows.length),
          target_cost: num(rate.amount),
          source_hotel_id: hotel?.id,
          source_night: rate.night,
        });
      });
      return;
    }

    const totalCost = num(hotel?.total_cost);
    if (totalCost !== 0) {
      rows.push({
        ...emptyHotelItem(hotelTotalLabel(hotel, hotelIndex, multipleHotels), rows.length),
        target_cost: totalCost,
        source_hotel_id: hotel?.id,
        source_night: 1,
        is_legacy_total: true,
      });
    }
  });

  return rows;
}

function mergeSavedHotelRows(baseRows, savedRows) {
  if (!savedRows.length) return baseRows;
  if (!baseRows.length) return savedRows;

  if (savedRows.length === 1) {
    return [
      {
        ...baseRows[0],
        ...savedRows[0],
        item_label: baseRows[0].item_label,
        sort_order: baseRows[0].sort_order,
        target_cost: baseRows[0].target_cost,
        source_hotel_id: baseRows[0].source_hotel_id,
        source_night: baseRows[0].source_night,
        is_legacy_hotel_value_moved: baseRows.length > 1,
      },
      ...baseRows.slice(1),
    ];
  }

  const nextRows = baseRows.map((base, index) => {
    const saved = savedRows[index];
    if (!saved) return base;
    return {
      ...base,
      ...saved,
      item_label: base.item_label,
      sort_order: base.sort_order,
      target_cost: base.target_cost,
      source_hotel_id: base.source_hotel_id,
      source_night: base.source_night,
    };
  });

  for (let index = baseRows.length; index < savedRows.length; index += 1) {
    nextRows.push({ ...savedRows[index], is_additional: true, sort_order: index });
  }
  return nextRows;
}

export function initialHotelRows(savedRows, baseline = {}, sourceHotels = []) {
  const baseRows = sourceHotelRows(sourceHotels);
  if (baseRows.length) return mergeSavedHotelRows(baseRows, savedRows);
  if (savedRows.length) {
    return savedRows.map((row, index) => ({
      ...row,
      is_additional: index > 0,
      sort_order: index,
    }));
  }

  const baselineAmount = num(baseline.hotel_total);
  return [{
    ...emptyHotelItem('호텔 · 1박', 0),
    target_cost: baselineAmount || null,
    source_night: 1,
    is_legacy_total: true,
  }];
}

export function createAdditionalHotelRow(index) {
  return {
    ...emptyHotelItem(`추가 ${index + 1}박`, index),
    is_additional: true,
    source_night: index + 1,
  };
}
